import { useState } from 'react';
import type { FieldValues, UseFormReturn } from 'react-hook-form';
import { Box } from '@mui/material';

import { ReactComponent as ArchiveIcon } from 'assets/images/ic-archive-dispensary.svg';
import { ContainerItem, InputSelect, Text } from 'ui';

interface Props {
  templateOptions: {
    value: string;
    label: string;
    published: boolean;
    plant_touching: boolean;
    archivedOption: boolean;
  }[];
  setSelectedTemplateId: (selected: string) => void;
  form: UseFormReturn<FieldValues, any, undefined>;
}

export const DueDiligenceList = (props: Props) => {
  const [showArchived, setShowArchived] = useState(false);
  return (
    <ContainerItem dataCy="reports-dd-template-list" width="100%" margin="0 0 10px 0" padding="0">
      <Box
        data-cy="toggle-archived"
        onClick={() => setShowArchived(!showArchived)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          position: 'relative',
          top: '20px',
          cursor: 'pointer',
          zIndex: '1'
        }}
      >
        <Text
          sx={{ fontWeight: '700', fontSize: '13px', color: '#828599', marginRight: '4px' }}
          content={showArchived ? 'Hide archived' : 'Show archived'}
        />
        <ArchiveIcon />
      </Box>
      <InputSelect
        placeholder="No templates found"
        name="dueDiligenceTemplate"
        label="Due Diligence Template"
        defaultValue={!!props.templateOptions?.length ? props.templateOptions[0].value : undefined}
        options={props.templateOptions.filter((o) => {
          if (showArchived) {
            return true;
          }
          return !o.archivedOption;
        })}
        additionalOnChange={(e) => props.setSelectedTemplateId(e.target.value)}
        addTag="Marijuana-Licensed"
        rules={{ required: { message: 'is required', value: true } }}
        {...props.form}
      />
    </ContainerItem>
  );
};
